module.exports = __webpack_public_path__ + "static/MasterBath1-415b36d597723465c2596ceb0fcfe8a7.jpg";